export default __webpack_public_path__ + "static/media/logo.8f991ca1.svg";